export enum TemplateOrderField {
  DEFAULT = 'Default',
  NAME = 'Name',
  CREATION_DATE = 'CreationDate',
  LAST_MODIFIED = 'LastModified',
}
